<template>
  <div class="article-locale" :class="`article-locale--${articleLocale}`">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    /**
     * Article locale code
     */
    articleLocale: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.article-locale {
  @apply mx-auto break-words;
}

/* Chinese-only layout */
.article-locale.article-locale--zh-hant::v-deep {
  & *:not(h1):not(h2) {
    line-height: 1.8;
  }
  & h1,
  & h2 {
    @apply leading-normal;
  }
}
.article-locale.article-locale--zh-hant::v-deep .article-main,
.article-locale.article-locale--zh-hant::v-deep .list.list--articles {
  & *:not(h1):not(h2) {
    letter-spacing: 1px;
  }
  & h1,
  & h2 {
    letter-spacing: 0;
  }
  & h4,
  & h5,
  & h6,
  & p {
    text-indent: 2em;
  }
  & li > p,
  & .article-byline {
    text-indent: 0;
  }
}

@screen desktop {
  /* Chinese-only layout */
  .article-locale.article-locale--zh-hant::v-deep {
    & *:not(h1):not(h2) {
      @apply text-justify;
    }
    & h1,
    & h2 {
      @apply text-left;
    }
  }
}
</style>
